<template>
  <div class="wrapper" ref="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button/>
    <side-bar
      v-if="!loggedUser.active"
      :background-color="sidebarBackground"
    >
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{
            name: $t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: '/dashboard'
          }"
        >
        </sidebar-item>
      </template>
    </side-bar>
    <side-bar
      v-if="loggedUser.active"
      :background-color="sidebarBackground"
    >
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{
            name: $t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: '/dashboard'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="loggedUser.role == UserRoles.APPLICANT"
          :link="{
            name: $t('sidebar.ongoing_applications'),
            icon: 'tim-icons icon-notes',
            path: '/ongoing-applications'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="loggedUser.role !== UserRoles.APPLICANT"
          :link="{
            name: $t('sidebar.applications'),
            icon: 'tim-icons icon-notes',
            path: '/applications'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="loggedUser.role == UserRoles.APPLICANT"
          :link="{
            name: $t('sidebar.current_grants'),
            icon: 'tim-icons icon-app',
            path: '/grants'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="loggedUser.role == UserRoles.ADMIN"
          :link="{
            name: 'Translations',
            icon: 'tim-icons icon-chat-33'
          }"
        >
          <sidebar-item
            :link="{
            name: 'Translations',
            path: '/translations/translations'
          }"
          >
          </sidebar-item>
          <sidebar-item
            :link="{
            name: 'Languages',
            path: '/translations/languages'
          }"
          >
          </sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="loggedUser.role == UserRoles.ADMIN"
          :link="{
            name: $t('sidebar.messaging'),
            icon: 'tim-icons icon-email-85',
            path: '/messaging'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="loggedUser.role == UserRoles.ADMIN || loggedUser.role == UserRoles.REGIONAL_ADMIN || loggedUser.role == UserRoles.AUDITOR"
          :link="{
            name: $t('sidebar.monitoring'),
            icon: 'tim-icons icon-check-2',
            path: '/monitoring'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="loggedUser.role == UserRoles.APPLICANT"
          :link="{
            name: $t('sidebar.applicant_monitoring'),
            icon: 'tim-icons icon-check-2',
            path: '/monitoring'
          }"
        >
        </sidebar-item>
        <!-- Log Monitoring -->
        <sidebar-item
          v-if="loggedUser.role == UserRoles.ADMIN || loggedUser.role == UserRoles.REGIONAL_ADMIN || loggedUser.role == UserRoles.AUDITOR"
          :link="{
            name: $t('sidebar.logmonitoring'),
            icon: 'tim-icons icon-notes',
            path: '/logmonitoring'
          }"
        >
        </sidebar-item>
        <sidebar-item
            v-if="loggedUser.role !== UserRoles.AUDITOR"
          :link="{
            name: $t('sidebar.requests'),
            icon: 'tim-icons icon-alert-circle-exc',
            path: '/clarifications'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="loggedUser.role !== UserRoles.APPLICANT && loggedUser.role !== UserRoles.AUDITOR"
          :link="{
            name: $t('sidebar.reports'),
            icon: 'tim-icons icon-single-copy-04',
            path: '/reports'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="loggedUser.role == UserRoles.ADMIN"
          :link="{
            name: $t('sidebar.user_management'),
            icon: 'tim-icons icon-single-02',
            path: '/users-management'
          }"
        >
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';
  import {SlideYDownTransition, ZoomCenterTransition} from 'vue2-transitions';
  import {UserRoles} from "@/services";

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      SidebarFixedToggleButton,
      DashboardContent,
      SlideYDownTransition,
      ZoomCenterTransition
    },
    data() {
      return {
        UserRoles,
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary,
      };
    },
    computed: {
      loggedUser() {
        return this.$store.getters['Auth/loggedUser'];
      }
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      initScrollbar() {
        let docClasses = document.body.classList;
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          // if we are on windows OS we activate the perfectScrollbar function
          initScrollbar('sidebar');
          initScrollbar('main-panel');
          initScrollbar('sidebar-wrapper');

          docClasses.add('perfect-scrollbar-on');
        } else {
          docClasses.add('perfect-scrollbar-off');
        }
      }
    },
    mounted() {
      // this.initScrollbar();
    }
  };
</script>
<style lang="scss">
  $scaleSize: 0.95;
  @keyframes zoomIn95 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
      opacity: 1;
    }
  }

  .main-panel .zoomIn {
    animation-name: zoomIn95;
  }

  @keyframes zoomOut95 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }

  .main-panel .zoomOut {
    animation-name: zoomOut95;
  }
</style>
